import { reportClientError } from 'services/errorReportingService'

export function blobToBase64(blob: Blob) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()

    reader.onloadend = () => {
      if (reader.result && typeof reader.result === 'string') {
        const base64String = reader.result.split(',')[1]
        if (base64String) {
          resolve(base64String)
        } else {
          const error = new Error('Failed to extract base64 string from data URL')
          reportClientError(error, {
            message: 'Blob to base64 conversion failed - could not extract base64 string',
            blobSize: blob.size,
            blobType: blob.type,
            resultType: typeof reader.result,
            resultLength: reader.result.length,
          })
          reject(error)
        }
      } else {
        const error = new Error('Failed to read blob as base64')
        reportClientError(error, {
          message: 'Blob to base64 conversion failed - invalid result',
          blobSize: blob.size,
          blobType: blob.type,
          resultType: typeof reader.result,
        })
        reject(error)
      }
    }

    reader.onerror = () => {
      const error = new Error('Error reading blob')
      reportClientError(error, {
        message: 'FileReader error occurred during blob to base64 conversion',
        blobSize: blob.size,
        blobType: blob.type,
        errorCode: reader.error?.code,
        errorMessage: reader.error?.message,
      })
      reject(error)
    }

    reader.onabort = () => {
      const error = new Error('Blob reading was aborted')
      reportClientError(error, {
        message: 'FileReader abort occurred during blob to base64 conversion',
        blobSize: blob.size,
        blobType: blob.type,
      })
      reject(error)
    }

    reader.readAsDataURL(blob)
  })
}
